(function () {
  var MOBILE_MQ = '(max-width: 989px)';

  function isMobileViewport() {
    return window.matchMedia(MOBILE_MQ).matches;
  }

  function getMobilePageSize(root) {
    var size = parseInt(root.dataset.mobilePageSize || '5', 10);
    if (Number.isNaN(size) || size < 1) return 5;
    return size;
  }

  function isMoreSectionExpanded(moreSection) {
    if (!moreSection) return false;
    if (moreSection.style.display === 'contents') return true;
    return window.getComputedStyle(moreSection).display !== 'none';
  }

  function getFeaturedCards(root) {
    var grid = root.querySelector('.customers-featured__grid');
    if (!grid) return [];

    var moreSection = document.getElementById('customers-featured-more');
    var expanded = isMoreSectionExpanded(moreSection);

    return Array.prototype.slice.call(grid.querySelectorAll('.customers-featured__card')).filter(function (card) {
      if (moreSection && moreSection.contains(card)) return expanded;
      return true;
    });
  }

  function getAllPremiumCards(root) {
    var grid = root.querySelector('.customers-featured__grid');
    if (!grid) return [];
    return Array.prototype.slice.call(grid.querySelectorAll('.customers-featured__card--premium'));
  }

  function applyFeaturedMobilePagination(root, resetLimit) {
    var loadMoreBtn = root.querySelector('#customers-featured-load-more');
    var standardToggle = document.getElementById('customers-featured-toggle');
    var pageSize = getMobilePageSize(root);
    var cards = getFeaturedCards(root);

    if (!isMobileViewport()) {
      cards.forEach(function (card) {
        card.classList.remove('customers-featured__card--mobile-collapsed');
      });
      if (loadMoreBtn) loadMoreBtn.hidden = true;
      if (standardToggle) standardToggle.style.display = '';
      root.dataset.mobileVisibleLimit = '';
      return;
    }

    var limit = resetLimit
      ? pageSize
      : parseInt(root.dataset.mobileVisibleLimit || String(pageSize), 10);
    if (Number.isNaN(limit) || limit < pageSize) limit = pageSize;

    root.dataset.mobileVisibleLimit = String(limit);

    cards.forEach(function (card, index) {
      card.classList.toggle('customers-featured__card--mobile-collapsed', index >= limit);
    });

    if (loadMoreBtn) {
      loadMoreBtn.hidden = limit >= cards.length;
    }

    if (standardToggle) {
      var allPremium = getAllPremiumCards(root);
      var allPremiumShown = limit >= allPremium.length;
      standardToggle.style.display = allPremiumShown ? '' : 'none';
    }
  }

  function initFeaturedStandardToggle(root) {
    var toggleBtn = document.getElementById('customers-featured-toggle');
    var moreSection = document.getElementById('customers-featured-more');
    if (!toggleBtn || !moreSection) return;

    toggleBtn.addEventListener('click', function () {
      moreSection.style.display = 'contents';
      toggleBtn.style.display = 'none';
      applyFeaturedMobilePagination(root, false);
    });
  }

  function initFeaturedMobilePagination(root) {
    if (!root) return;

    var loadMoreBtn = root.querySelector('#customers-featured-load-more');
    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', function () {
        var pageSize = getMobilePageSize(root);
        var current = parseInt(root.dataset.mobileVisibleLimit || String(pageSize), 10);
        root.dataset.mobileVisibleLimit = String(current + pageSize);
        applyFeaturedMobilePagination(root, false);
      });
    }

    var mobileMedia = window.matchMedia(MOBILE_MQ);
    if (mobileMedia.addEventListener) {
      mobileMedia.addEventListener('change', function () {
        applyFeaturedMobilePagination(root, true);
      });
    }

    applyFeaturedMobilePagination(root, true);
  }

  document.addEventListener('DOMContentLoaded', function () {
    var root = document.getElementById('customers-featured-root');
    initFeaturedMobilePagination(root);
    initFeaturedStandardToggle(root);
  });
})();
